/** @format */
/** A custom Hook that redirects users to private routes and redirects them to a given url when not authenticated */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { logoutRequestAction } from 'stateContainer/actions';

import { Route, Redirect, useLocation } from 'react-router-dom';

export default function PrivateRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();

  const { isAuthenticated, sessionEndTime } = useSelector(
    (state) => state.session
  );

  React.useEffect(() => {
    const sessionHasExpired = new Date(sessionEndTime) < new Date();
    if (sessionHasExpired) {
      dispatch(logoutRequestAction());
    }
  }, [sessionEndTime]);

  return (
    <>
      <Route {...rest}>
        {isAuthenticated ? (
          <>{children}</>
        ) : (
          <Redirect to={`/?redirect=${pathname}${search}`} />
        )}
      </Route>
    </>
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired
};
